import React, { createRef, useRef } from 'react';
import styled from 'styled-components';
import HeaderEs from '../header/HeaderEs';
import SpanPrice from '../price/SpanPrice';
import SpanPckgNavPrice from '../price/SpanPckgNavPrice';
import NormalInput from '../input/NormalInput';
import CountInputBtn from '../button/CountInputBtn';
import ApplyPckgProdImg from '../image/ApplyPckgProdImg';
import SrMyCartDvry from '../../sr/SrMyCartDvry';
import CurrencyInput from 'react-currency-input-field';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Modal from 'react-modal';
import NormalPopupOneBtn from './NormalPopupOneBtn';
import NormalPopup, { customModalStyles } from './NormalPopup';
import { EsApplyInfoDao, setEsApplyDelAllAction, reqEsApplyAction } from '../../../modules/es/esApplyModule';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { removeUserCartProdBrandAction } from '../../../modules/su/userCartModule';
import { Log } from '../../../lib/util/CustomUtil';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { split } from 'lodash';
import { isMobileOnly } from 'react-device-detect';
import CurrencyInputComp from '../input/CurrencyInputComp';
import LoginPopup, { LoginPopupStyles } from './LoginPopup';
import { reqEsItemListAction, reqEsItemListIngAction} from '../../../modules/es/esItemModule';
import { EnCryptData } from '../../../lib/util/CustomUtil';
import { remove, findIndex, forEach } from 'lodash';
import * as CONSTANTS from '../../../lib/util/Constants';

// Modal Stryle
export const EsReqPopupModalStyles = {
    content: {
        /* top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)', */
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        postion: 'fixed',

        zIndex: '999',
        overlay: 'auto',
        WebkitOverflowScrolling: 'touch',
        width: "100%",
        height: "100%",
        borderRadius: '0px',
        backgroundColor: '#fff',
        borderWidth: '0px',
        padding: '0px',
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: '1000'
    }
};

const EsReqInfoPopupBlock = styled.div`
      .btn-quote-block {
        width: 100%;
        padding: 18px 20px;
        background-color: rgb(244, 244, 244);
        text-align: center;      
         position:fixed;
         bottom:0;
         z-index: 10;
         button { font-weight: 600;}
        .btn-text { display: flex; justify-content: space-around; align-items: center; }        
     }     

     .Toastify__toast {
        background-color: #fff;
        color: #333;
        border-radius: 10px;
        min-width: 330px;
        font-size: 16px;
        padding: 30px;
    }

    .Toastify__toast-container {
        position: fixed;
        margin: auto;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        bottom: auto;
    }
`;

const EsReqWrapBlock = styled.div`
    padding: 92px 0 0 0;
    height:100vh; 
    overflow-y: scroll;
    
    ${isMobileOnly ?
        `
        margin: 0 4vw;        
        .es_title-box {
            // margin-top: 40px;
            .inputbox {margin-bottom: 40px;}
            .total-price {
                padding-left: 40px;
                font-size: 14px;
                display:flex;
                align-items: center;
                justify-content: space-between;                
            }       
            
        }`:
        `
        width: 100%;
        max-width: 1176px;
        margin: 0 auto;
        
        .es_title-box {
            margin:60px 0;
            .inputbox {
                float: left;
                width: 568px;           
            }
            .total-price {
                width: 608px;
                float: right;
                text-align: left;
                padding-left: 40px;
                font-size: 14px;
                display:flex;
                align-items: center;
                justify-content: space-between;
                
            }       
          &: after {
             content: "."; 
             visibility: hidden; 
             display: block; 
             height: 0; 
             clear: both;              
           }
        }                  
    `};      
`;

const MobileEsReqBlock = styled.div`
    //margin: 80px 0;    
    .list-container {
      border-top: 2px solid #111;
      padding-top:20px;

    .item-block {
      display:flex;
      flex-direction: column;
      padding-bottom:1rem;
      border-bottom: 1px solid #ccc;
      margin-bottom:1rem;
      &:last-child {border-bottom: none;}
      
      .info {
        display: flex;                
       
        .name-container {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          width: 60vw;
          margin-left:1rem;
       
          .name, .option {
            text-overflow: ellipsis;            
            white-space: nowrap;
            overflow: hidden;          
          }
        }      
      }
      .control {
        display: flex;
        justify-content: space-between;
      }    
    }          
    }
    .brand-logo {float:left; width:30vw; object-fit: cover;}
    .brand-total {
      padding:20px 5px;
      border-top:2px solid #111;
      background-color: #ececec;
      display: flex;
      align-items: center; 
      justify-content: space-between;
     }
    .disired-amount {
      display: flex;
      align-items: center; 
      justify-content: space-between;
      margin-top:10px;    
    }
`;
const EsReqTableBlock = styled.table`
    width: 1176px;
    border-top: 2px solid #111;
`;

const EsReqTdBlock = styled.td`
    padding: ${props => props.padding || '20px 0px 20px 0px'} ;
    text-align: ${props => props.align || 'center'};
    vertical-align: ${props => props.valign || 'middle'};
    border-top: 1px solid #ccc;
    position: relative;
    font-size: 14px;
`;

const EsReqTdTitleBlock = styled.p`
    display: -webkit-box;
    height: 42px;
    font-size: 14px;
    word-wrap: break-word;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    margin-top: -3px;
`;

const EsReqTdOptionBlock = styled.div`
    position: absolute;
    bottom: 20px;
    color: #666;
    font-size: 14px;
`

const EsReqFootBlock = styled.td`
    background-color: rgba(0, 217, 184, 0.1);
    padding: 20px 0;
    vertical-align: middle;
    border-top: 1px solid #ccc;
    font-size: 14px;
    text-align: center;
`;

const EsReqThBlock = styled.th`
    padding: 20px 0;
    vertical-align: middle;
    border-top: 2px solid #111;
    font-size: 14px;
    text-align: center;
`;

let mPrdctId = null;
let mOptId = null;
const MAX_CNT = CONSTANTS.MAX_RQST_CNT;

const EsReqPopup = ({ cartItem, totalPrice, totalCnt, availCnt2, onCloseClick, handlerChangeCnt, handlerDelClick }) => {

    // console.log("cartItem : " + JSON.stringify(cartItem))
    // console.log("totalPrice : " + totalPrice)
    const dispatch = useDispatch();
    const history = useHistory();

    const [focused, setFocused] = useState(false);
    const [price, setPrice] = useState(0);

    const [openModal, setOpenModal] = useState(false);
    const [msg, setMsg] = useState("");
    const [msg1, setMsg1] = useState("")

    const [pckgNm, setPckgNm] = useState("");
    const [date, setDate] = useState();
    const [postNum, setPostNum] = useState("");
    const [addr, setAddr] = useState("");
    const [addr2, setAddr2] = useState("");
    const [area, setArea] = useState(0);
    const [place, setPlace] = useState(0);
    const [areaType, setAreaType] = useState(1);
    const [question, setQuestion] = useState("");
    const [priceConfirm, setPriceConfirm] = useState(1); // 설치 비용
    const [availCnt, setAvailCnt] = useState(5);
    const [openModalLogin, setOpenModalLogin] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [request, setRequest] = useState(false);

    const pckgNmRef = useRef(null);
    const priceRef = useRef(null);
    const addrRef = useRef(null);



    const { accessToken, esApplyResult, esItems, id } = useSelector(
        ({ userReducer, esApplyReducer, esItemsReducer }) => ({
            accessToken: userReducer.accessToken,
            esApplyResult: esApplyReducer.esApplyResult,
            esItems: esItemsReducer.esItems,
            id: userReducer.id,
        })
    );

    // #2625 - 수정
    // useEffect(() => {
    //     if (esApplyResult !== null && esApplyResult.code === 200) {
    //         // 스토어의 모든 정보 삭제
    //         dispatch(setEsApplyDelAllAction());
    //         history.push('/es');
    //     }
    // }, [esApplyResult])

    useEffect(() => {
        // console.log('aT',accessToken)
        if (esApplyResult !== null && esApplyResult.code === 200) {
            setShowToast(true);
            dispatch(setEsApplyDelAllAction());

            /* // console.log('SUCCESS???')
            // 스토어의 모든 정보 삭제
            toast.success('견적 요청이 완료되었습니다.', {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
            })

            setTimeout(() => {
                onCloseClick()
                dispatch(removeUserCartProdBrandAction(cartItem[0].brnd_id));
                history.push('/es');
            }, 2000);
            //onCloseClick(); */

            let message = "견적 요청이 완료되었습니다."
            setMsg1("");
            setMsg(message);
            setOpenModal(true);

            //주소 localstorage 저장하기
             if(accessToken !== null){
                let address = {};
                address.zipcode = postNum;
                address.addr1 = addr;
                address.addr2 = addr2;
                address.id = id;

                localStorage.setItem('address', EnCryptData(JSON.stringify(address)));
            }

        }
    }, [esApplyResult])

    useEffect(() => {
        if(accessToken !== null){
            if(request){
                //dispatch(reqEsItemListAction()); // 견적정보 get
                dispatch(reqEsItemListIngAction());
            } else {
                onCloseModalLogin();
                //dispatch(reqEsItemListAction()); // 견적정보 get
                dispatch(reqEsItemListIngAction());
            }
        }
    },[accessToken])

    useEffect(() => {
        // dispatch(reqEsItemListAction()); // 견적정보 get

        if (esItems !== null && esItems !== undefined) {
            const cnt = (MAX_CNT - esItems.length)<0?0:(MAX_CNT - esItems.length)
            try {
                if (esItems[0][0].rqst_status !== '050106') {
                    setAvailCnt(cnt)
                }
            } catch (e) { }

            if(request){
                onCloseModalLogin();
                if(cnt > 0){
                    handleSubmit();
                }else{
                    let message = "견적 요청 가능 수량 "+MAX_CNT+"건 모두 사용되었습니다.\n요청중인 견적서 취소 또는 주문이 이루어지면 견적 요청 가능합니다."
                    setMsg1("");
                    setMsg(message);
                    setOpenModal(true);
                }
            }
        }

    }, [esItems])

    const onOpenModalLogin = () => {
        setOpenModalLogin(true);
    }

    // Modal 닫기
    const onCloseModalLogin = () => {
        setOpenModalLogin(false);
    }

    const changeValueHandler = (prdct_id, opt_id, value) => {
        handlerChangeCnt(prdct_id, opt_id, value);
    }

    // Delete Btn Click
    const handleDelClick = (prdct_id, opt_id) => {

        mPrdctId = prdct_id;
        mOptId = opt_id;

        // console.log("prdct_id : " + prdct_id + " , opt_id : " + opt_id);

        setMsg1("상품 옵션을 ")
        setMsg("삭제하시겠습니까?")
        setOpenModal(true);

        // handlerDelClick(prdct_id, opt_id);
    }

    const handleChangePrice = (value, name) => {
        Log("EsReqPopup ChangePrice - value : " + value);
        setPrice(value);
    }

    // 패키지 금액 포커서 확인
    const handleChangeCurInputFocus = () => {
        // console.log("handleChangeCurInputFocus")
        setFocused(true);
    }

    const handleChangeCurInputBlur = () => {
        // console.log("handleChangeCurInputBlur")
        setFocused(false);
    }

    const handleCloseBtnClick = () => {

        setMsg1("작성중인 내용이 있습니다.")
        setMsg("정말 닫으시겠어요?")
        setOpenModal(true);
    }

    // Popup Confirm Btn Click
    const handleConfirmPopupClick = () => {

        if (msg1 === "작성중인 내용이 있습니다.") {
            onCloseClick();
        } else {
            // console.log("mPrdctId : " + mPrdctId + " , mOptId : " + mOptId);

            if (mPrdctId !== undefined && mOptId !== undefined) {
                handlerDelClick(mPrdctId, mOptId);
            }

            setOpenModal(false);
        }
    }

    // 견적 요청하기
    const handleSubmit = () => {

        if(showToast){
            return;
        }
        if(availCnt < 1){
            return;
        }
        // 견적 요청하고
        if (accessToken !== null) {

            if (checkValid()) {

                // 견적서 정보 저장
                let reqInfo = EsApplyInfoDao();
                reqInfo.rqst_status = "050102"; // 요청
                reqInfo.pckg_nm = pckgNm;
                reqInfo.rqst_price = price; // 희망 견적 금액
                reqInfo.es_prod_total_price = totalPrice;
                reqInfo.brnd_cd = cartItem[0].brnd_cd;
                reqInfo.es_prod_cnt = totalCnt;
                reqInfo.dsrd_date = date;
                reqInfo.zipcode = postNum;
                reqInfo.addr1 = addr;
                reqInfo.addr2 = addr2;
                reqInfo.area_type = areaType;
                reqInfo.area_size = area;
                reqInfo.is_install_chrg = priceConfirm;
                reqInfo.house_type = place;
                reqInfo.es_question = question;

                // 스토어의 모든 정보 삭제
                dispatch(setEsApplyDelAllAction());

                // 로컬 삭제
                //dispatch(removeUserCartProdBrandAction(cartItem[0].brnd_id));

                // 서버로 견적서 요청
                dispatch(reqEsApplyAction(accessToken, reqInfo, cartItem));
            }


        } else {
            if(checkValid()){
                setRequest(true);
                // 로그인 팝업 표시
                onOpenModalLogin();
            }
        }
    }

    const checkValid = () => {

        setMsg1("");

        if (totalCnt < CONSTANTS.MIN_ITEM) {
            setMsg(`상품의 갯수가 ${CONSTANTS.MIN_ITEM}개 이상 이어야 견적 요청이 가능합니다.`)
            setOpenModal(true);
            return false;
        }

        // 패키지 이름 확인
        if (pckgNm === null || pckgNm.length === 0) {
            setMsg("나의 견적서 이름을 입력해 주세요.");

            if (pckgNmRef.current) {
                pckgNmRef.current.focus();
            }

            setOpenModal(true);
            return false;
        }

        if (price === 0) {
            setMsg("희망 견적 금액을 입력해 주세요.");
            if (priceRef.current) {
                priceRef.current.focus();
            }
            setOpenModal(true);
            return false;
        }

        if (addr === null || addr === "") {
            setMsg("배송지역을 입력해 주세요.")
            if (addrRef.current) {
                addrRef.current.focus();
            }
            setOpenModal(true);
            return false;
        }

        if (addr2 === null || addr2 === "") {
            setMsg("배송지역을 입력해 주세요.");
            if (addrRef.current) {
                addrRef.current.focus();
            }
            setOpenModal(true);
            return false;
        }


        return true;
    }

    const handleOneBtnPopupClick = () => {
        setOpenModal(false);
        if(showToast){
            onCloseClick();
            dispatch(removeUserCartProdBrandAction(cartItem[0].brnd_id));
            history.push('/es');
        }
    }

    const getCurDate = () => {
        let curdate = new Date();
        return curdate.toISOString().slice(0, 10).replace('T', ' ')
    }

    const getCateName = (cate_name) => {

        if (cate_name !== null) {
            let catenames = split(cate_name, '>');
            return catenames[1];
        }

        return "";
    }

    return (
        <EsReqInfoPopupBlock>
            <HeaderEs rqst_id={null}
                name={cartItem[0].brnd_nm}
                onCloseClick={handleCloseBtnClick}
                bgColor="#ffc742"
            />

            <EsReqWrapBlock>
                <div className="es_title-box">
                    <div className="inputbox">
                        <NormalInput width="100%" maxLength='25'
                            placeholder='나의 견적서 이름을 입력해 주세요.'
                            inputRef={pckgNmRef}
                            onChange={(e) => { setPckgNm(e.target.value) }} />
                    </div>
                </div>

                {/* 상품 리스트  */}
                <div className="margin_b-80">
                    {isMobileOnly ?
                        <MobileEsReqBlock>
                            <div className="list-container">
                                {cartItem.map((item, index) => {
                                    return (
                                        <div className="item-block" key={item.prdct_id + item.opt_id}>
                                            <div className="info">
                                                <ApplyPckgProdImg img={item.img}
                                                    id={item.prdct_id}
                                                    onDelClick={() => { handleDelClick(item.prdct_id, item.opt_id) }}
                                                    alwaysShowDelBtn={true}/>
                                                <div className="name-container">
                                                    <div className="name">{item.prdct_nm}</div>
                                                    <div className="option">{item.opt_nm}</div>
                                                </div>
                                            </div>
                                            <div className="control">
                                                <CountInputBtn
                                                    changeValueHandler={changeValueHandler}
                                                    num={item.qty}
                                                    item={item}
                                                    width="33px" height="30px" />
                                                <SpanPckgNavPrice value={item.es_prdct_price}
                                                    fontSize='20px' fontWeight='700' float='none' />

                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            <div className='brand-total'>
                                <div>총 수량 <SpanPrice value={totalCnt} isSale={false} />개</div>
                                <div><SpanPckgNavPrice value={totalPrice} fontSize='20px' fontWeight='700' float='none' /></div>
                            </div>

                            <div className="disired-amount">
                                <div>희망 견적 금액</div>
                                <div style={{ position: "relative" }}>
                                    <CurrencyInput
                                        id="input-example"
                                        name="input-name"
                                        placeholder="0"
                                        defaultValue={0}
                                        allowDecimals={false}
                                        onChange={handleChangePrice}
                                        onFocus={handleChangeCurInputFocus}
                                        onBlur={handleChangeCurInputBlur}
                                        maxLength="14"
                                        style={{
                                            height: "40px",
                                            border: focused ? "1px solid #ffc742" : "1px solid #ccc",
                                            outline: "0",
                                            borderRadius: "4px",
                                            paddingRight: "32px",
                                            width: "171px",
                                            textAlign: 'right',
                                            fontSize: '14px',
                                            fontWeight: '700'
                                        }}

                                    />
                                    <span style={{
                                        position: 'absolute', right: '10px', top: '6px'
                                    }}>
                                        원
                                    </span>
                                </div>
                            </div>

                        </MobileEsReqBlock>
                        :
                        <EsReqTableBlock>
                            <colgroup>
                                <col width="120px;" />
                                <col width="710px;" />
                                <col width="124px;" />
                                <col width="221px;" />
                            </colgroup>

                            <thead>
                                <tr>
                                    <EsReqThBlock colSpan="2">상품 정보</EsReqThBlock>
                                    <EsReqThBlock>수량</EsReqThBlock>
                                    <EsReqThBlock>판매금액</EsReqThBlock>
                                </tr>
                            </thead>

                            <tbody>
                                {
                                    cartItem.map((item, idx) => {

                                        return (
                                            <tr key={item.prdct_id + item.opt_id}>
                                                <EsReqTdBlock>
                                                    <ApplyPckgProdImg
                                                        img={item.img}
                                                        id={item.prdct_id}
                                                        cateName={getCateName(item.cate_fullname)}
                                                        onDelClick={() => { handleDelClick(item.prdct_id, item.opt_id) }} />
                                                </EsReqTdBlock>
                                                <EsReqTdBlock align='left' valign='top'>
                                                    <EsReqTdTitleBlock>
                                                        <span style={{ color: '#333' }}>
                                                            {item.prdct_nm}
                                                        </span>
                                                    </EsReqTdTitleBlock>

                                                    <EsReqTdOptionBlock >
                                                        <p style={{ marginBottom: '3px' }}>
                                                            <span>{item.opt_nm}</span>
                                                        </p>
                                                    </EsReqTdOptionBlock>

                                                </EsReqTdBlock>
                                                <EsReqTdBlock >
                                                    <div style={{ marginLeft: '6px' }}>
                                                        <CountInputBtn
                                                            changeValueHandler={changeValueHandler}
                                                            num={item.qty}
                                                            item={item}
                                                            width="33px" height="30px" />
                                                    </div>
                                                </EsReqTdBlock>
                                                <EsReqTdBlock>
                                                    <SpanPckgNavPrice value={item.es_prdct_price}
                                                        fontSize='20px' fontWeight='700' float='none' />

                                                </EsReqTdBlock>
                                            </tr>
                                        );
                                    })
                                }
                            </tbody>

                            <tfoot>
                                <tr>
                                    <EsReqFootBlock colSpan="2"></EsReqFootBlock>
                                    <EsReqFootBlock>
                                        총 수량 <SpanPrice value={totalCnt} isSale={false} />개
                              </EsReqFootBlock>
                                    <EsReqFootBlock>
                                        <SpanPckgNavPrice value={totalPrice} fontSize='20px' fontWeight='700' float='none' />
                                    </EsReqFootBlock>
                                </tr>
                                <tr>
                                    <EsReqTdBlock colSpan="4">
                                        <div style={{ float: 'right' }}>

                                            <span className="fontsize-15 gray-text f-left"
                                                style={{ marginTop: '10px' }} >
                                                희망 견적 금액
                                            </span>

                                            <CurrencyInputComp
                                                marginLeft='60px'
                                                width='180px'
                                                float='left'
                                                marginRight='33px'
                                                placeholder='0'
                                                onChange={handleChangePrice}
                                                onFocus={handleChangeCurInputFocus}
                                                onBlur={handleChangeCurInputBlur}
                                                maxLength='14'
                                                inputRef={priceRef}
                                                textAlign='right'
                                            />

                                            <span style={{ position: 'relative', right: '55px', top: '9px' }}>
                                                원
                                            </span>

                                        </div>

                                    </EsReqTdBlock>
                                </tr>
                            </tfoot>
                        </EsReqTableBlock>
                    }

                </div>

                {/* 배송 정보 및 추가 사항 */}
                <div className="default-table margin_b-80" style={isMobileOnly ? {}:{width:'1176px'}}>
                    <h3 className="dt-title">배송 정보 및 추가 사항</h3>

                    <SrMyCartDvry
                        postNumHandler={(param) => { setPostNum(param) }}
                        dateHandler={(param) => { setDate(param) }}
                        addrHandler={(param) => { setAddr(param) }}
                        addr2Handler={(param) => { setAddr2(param) }}
                        areaTypeHandler={(param) => { setAreaType(param) }}
                        placeHandler={(param) => { setPlace(param) }}
                        areaHandler={(param) => { setArea(param) }}
                        questionHandler={(param) => { setQuestion(param) }}
                        priceConfirmHandler={(param) => { setPriceConfirm(param) }}
                        reffer={addrRef}
                    />

                </div>

                <div className="es_apply_info-box">
                    <p className="eai-title ">
                        견적 요청 시 중간 수정이 불가하며
                    </p>
                    {isMobileOnly ?
                        <div>
                        <p className="eai-title">판매자가 회원님께 제안한 견적서는</p>
                        <p className="eai-title margin_b-30">[가구견적] 메뉴에서 확인 가능합니다.</p>
                        </div>
                    :
                        <p className="eai-title margin_b-30">판매자가 회원님께 제안한 견적서는 [가구견적] 메뉴에서 확인 가능합니다.</p>
                    }
                    <p className="margin_b-120" style={isMobileOnly ? {marginBottom:'200px'}:{}}>
                        견적 요청일 :
                    <span className="font-mont" style={{ fontWeight: '700', marginLeft: '5px' }}>
                            {getCurDate()}
                        </span>
                    </p>

                </div>

            </EsReqWrapBlock>
            {/*{isMobileOnly?*/}
            {/*    <div className="btn-quote-block" onClick={availCnt>0?handleSubmit:null}>*/}
            {/*<NormalSmallBtn*/}
            {/*  marginBottom="10px"*/}
            {/*  height="60px"*/}
            {/*  width="92vw"*/}
            {/*  display='inline-block'*/}
            {/*  bgColor={availCnt>0?'rgb(255,199,66)':'#ccc'}*/}
            {/*  textColor={availCnt>0?'#111':'#999'} fontSize="1.2rem" fontWeight="400"*/}
            {/*  text="견적요청"*/}
            {/*  onClick={()=>availCnt>0?handleSubmit:null} //opens only when slots left*/}
            {/*/>*/}
            {/*</div>:*/}
            <div className="btn-quote-block" >
                {availCnt > 0 ?
                    <button className="mh-btn yellow-btn" onClick={handleSubmit}
                        style={{ fontWeight: '400' }}>
                        견적 요청하기
                    </button>
                    :
                    <button className="mh-btn lgray-btn"
                        style={{ fontWeight: '400' , pointerEvents : 'none'}}>
                        견적 요청초과
                    </button>
                }
                <ToastContainer />
            </div>
            {/*}*/}
            <Modal
                isOpen={openModal}
                onRequestClose={handleOneBtnPopupClick}
                style={customModalStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {
                    msg1 === "" ?
                        <NormalPopupOneBtn
                            text=""
                            text2={msg} text3=""
                            btn="확인" onClick={handleOneBtnPopupClick} /> :
                        <NormalPopup
                            text=""
                            text2={msg1}
                            text3={msg}
                            fontWeight3='500'
                            btn1="예" btn2="아니오"
                            onClick1={handleConfirmPopupClick}
                            onClick2={() => { setOpenModal(false) }} />
                }

            </Modal>
            <Modal
                isOpen={openModalLogin}
                onRequestClose={onCloseModalLogin}
                style={LoginPopupStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <LoginPopup onClosePopup={onCloseModalLogin}/>
            </Modal>
        </EsReqInfoPopupBlock>
    );
};

export default EsReqPopup;
